<template>
  <div class="home pa-4">
    <h1 class="title">About GIS Alerts</h1>
    <p class="body-1 mt-4">
The GIS Alerts app is the official Government messaging system used to immediately disseminate critical information to the general public. </p>
<p class="body-1"> It is an initiative of the Barbados Government Information Service and continues to demonstrate our commitment to serving the people of Barbados through the use of modern, relevant technologies.
</p>
<p class="body-1">To learn more about this initiative please visit <a href="https://gisbarbados.gov.bb" target="_blank">   https://gisbarbados.gov.bb </a>
      </p>
  </div>
</template>
<script>
export default {
  
}
</script>
